import React from 'react';

import {
    Wrapper,
    Image,
    MainContent,
    Heading,
    Description
} from './HowMuchIsMyHomeWorth.styles';
import homeWorthSvg from 'public/assets/homepage/home-worth.svg';

import homepageTranslations from 'public/locales/en/homepage.json';
import { getTranslator } from '../../../shared/i18n/getTranslator';
import { GetHomeWorthEstimateForm } from 'shared/components/GetHomeWorthEstimateForm/GetHomeWorthEstimateForm';

const t = getTranslator(homepageTranslations);

const headlineText = t('home_worth.headline');
const descriptionText = t('home_worth.description');

const homeWorthSvgDimensions = { width: 589, height: 331 };

export type HowMuchIsMyHomeWorthProps = {
    isLoggedIn: boolean;
};

export const HowMuchIsMyHomeWorth = (props: HowMuchIsMyHomeWorthProps) => {
    const { isLoggedIn } = props;

    return (
        <>
            <Wrapper isLoggedIn={isLoggedIn}>
                <Image
                    isLoggedIn={isLoggedIn}
                    src={homeWorthSvg}
                    width={homeWorthSvgDimensions.width}
                    height={homeWorthSvgDimensions.height}
                    alt=""
                />
                <MainContent isLoggedIn={isLoggedIn}>
                    <Heading size="6" isLoggedIn={isLoggedIn}>
                        {headlineText}
                    </Heading>
                    <Description isLoggedIn={isLoggedIn}>
                        {descriptionText}
                    </Description>
                    <GetHomeWorthEstimateForm eventCategory="homepage" />
                </MainContent>
            </Wrapper>
        </>
    );
};
